import request from '@/utils/request'

export const visitSave = (data: { moduleCode: number; trackId?: string }) =>
  request({
    url: '/blackcat/audit/visit/save',
    method: 'post',
    data
  })

/**
 * 模块访问统计--全量
 * @param params startDate 开始时间 endDate结束时间
 * @returns
 */
export const visitModuleAll = (params: { startDate: Date; endDate: Date }) =>
  request({
    url: 'blackcat/audit/visit/module/all',
    method: 'get',
    params
  })

/**
 * 企业模块权限-固定
 * @param params
 * @returns
 */
export const tenantModuleList = () =>
  request({
    url: '/blackcat/audit/visit/tenant/module',
    method: 'get',
    headers: {
      tenantId: 1001
    }
  })

/**
 * f访问记录分页
 * @param params
 * @returns
 */
export const tenantTable = (params: { page: number; size: number }) =>
  request({
    url: 'blackcat/audit/visit/page',
    method: 'get',
    params
  })

/**
 * 文件导出 - 统计
 * @param params
 * @returns
 */
export const fileDownload = (params: {
  startDate: string;
  endDate: string;
  tenantIdParam: number;
  access_token: string
}) =>
  request({
    url: '/blackcat/audit/visit/file',
    method: 'get',
    params
  })
